module.exports = __webpack_public_path__ + "static/media/icon-eye-black.62517b9b.svg";